module.exports = __webpack_public_path__ + "static/media/sl.5db99ab0.svg";